import {scaleLinear} from 'd3-scale'

export default function chunky(scale1,scale2) {
  
  var _scales = [scale1||scaleLinear(),scale2||scaleLinear()]
  
  
  var scale = (t)=>{
    if(_scales[0].domain()[0]<=t && t<=_scales[0].domain()[1]) {
      return _scales[0](t)
    } else {
      return _scales[1](t)
    }
  }
  scale.copy = function() {
    let copy = chunky(_scales[0].copy(),_scales[1].copy())
    copy._threshold = scale._threshold
    return copy
  };
  
  scale.domain = function(vals){
    if(vals){
      _scales[0].domain(vals[0])
      _scales[1].domain(vals[1])
      return scale
    } else {
      return [_scales[0].domain()[0],_scales[1].domain()[1]]
      // return _scales[0].domain()
    }
  }
  scale.range = function(vals){
    if(vals){
      _scales[0].range(vals[0])
      _scales[1].range(vals[1])
      return scale
    } else {
      return [_scales[0].range()[0],_scales[1].range()[1]]
      // return _scales[0].range()
    }
  }
  scale.subDomains = function(){
    return [_scales[0].domain(),_scales[1].domain()]
  }
  scale.subRanges = function(){
    return [_scales[0].range(),_scales[1].range()]
  }
  scale.ticks = function(val){
    let outlierTicks = _scales[1].ticks(2)
    outlierTicks = [outlierTicks[0],outlierTicks[outlierTicks.length-1]]
    return _scales[0].ticks(val-1).concat(outlierTicks)
    // if(val){
     
    //   return _scales[0].ticks(val)
    // } else {
    //   return _scales[0].ticks()
    // }
  }
  scale.isChunky = true

  // initRange.apply(scale, arguments);

  // return linearish(scale);
  return scale
}
